<template>
  <el-container>
<div style="width: 100%">
  <div class="d">
    <div class="order_title">订单基本信息</div>
    <el-form v-if="loginOrgCode == 'blcuonline'" :label-position="labelPosition" label-width="120px" :model="formLabelAlign" class="form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="订单编号:" size="small" style="width: 70%" >
            <el-input v-model="formData.orderNo" size="small" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单总额:" size="small" style="width: 70%" >
            <el-input v-model="formData.amount" @blur="updateAmount('amount')"  :disabled="formData.paymentStatus == 1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <!--<el-form-item label="用户名:" size="small" style="width: 70%">-->
            <!--<el-input v-model="formData.userName" :readonly="true" :disabled="true"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="支付方式:" size="small" style="width: 70%">
            <el-select v-model="formData.payType" placeholder="支付方式" size="small" :disabled="true">
              <el-option label="无" :value="0" v-if="formData.payType == 0"></el-option>
              <el-option label="支付宝/微信支付" :value="2"  v-if="formData.payType == 2"></el-option>
              <el-option label="银行汇款" :value="3"  v-if="formData.payType == 3"></el-option>
              <el-option label="现场支付" :value="4"  v-if="formData.payType == 4"></el-option>
              <el-option label="首信易支付" :value="6"  v-if="formData.payType == 6"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="支付状态:" size="small" style="width: 70%"  >
            <el-select v-model="formData.paymentStatus"  placeholder="支付状态" @change="updatePayStatus('paymentStatus')">
              <el-option label="已支付" :value="1" ></el-option>
              <el-option label="未支付" :value="0" ></el-option>
              <el-option label="支付中" :value="2" ></el-option>
              <el-option label="支付失败" :value="3" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="境内/境外:" size="small" style="width: 70%">
            <el-select v-model="formData.payRegion" placeholder="未知"  :disabled="true" >
              <el-option label="境内" :value="1" v-if="formData.payRegion == 1"></el-option>
              <el-option label="境外" :value="2" v-if="formData.payRegion == 2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手续费:" size="small" style="width: 70%">
          <el-input v-model="formData.bankFee" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="应付金额:" size="small" style="width: 70%">
            <el-input v-model="formData.totalDynamic" :disabled="true"  ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到账金额:" size="small" style="width: 70%">
            <el-input v-model="formData.realPay" @blur="updateAmount('realPay')" :disabled="formData.paymentStatus == 0"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="用户名:" size="small" style="width: 70%">
            <el-input v-model="formData.userName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="护照名:" size="small" style="width: 70%">
            <el-input v-model="formData.passportName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="生源:" size="small" style="width: 70%">
            <el-input v-model="formData.studentPool" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formData.payType == 3">
          <el-form-item label="汇款截图:">
            <el-upload
                v-if="!formData.screenshot"
                v-model="formData.screenshot"
                :action="uploadURL"
                :headers="myHeaders"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-success="pictureHandleSuccess"
                :before-upload="beforeAvatarUpload"
                :limit="2"
                :file-list="pictureFileList"
                :show-file-list="true"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <vue-hover-mask v-if="formData.screenshot" >
              <pdf :src="formData.screenshot"
                   v-if="screenType == 'pdf'"
                   :page="currentPage"
                   class="pdf1"
                   style="height: 200px; overflow: hidden"
                   @num-pages="pageCount=$event"
                   @page-loaded="currentPage=$event"
              >
              </pdf>
              <img style="height: 200px; overflow: hidden" v-if="screenType == 'img'"  :src="formData.screenshot" alt="">
              <template v-slot:action>
                <i class="el-icon-zoom-in" @click="showScreen"></i>
                <i class="el-icon-delete" @click="reUpload" style="margin-left: 15px"></i>
              </template>
              
            </vue-hover-mask>
            <el-dialog :visible.sync="screenshotDialog" size="tiny">
              <img width="100%" :src="formData.screenshot" alt="">
            </el-dialog>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    
  </div>
  <div class="d" v-if="formData.isStatement == 1">
    <div class="order_title">对账单信息</div>
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" class="form">
      <el-form-item label="个人或单位名称:">
        <el-input :disabled="true" v-model="formData.name"></el-input>
      </el-form-item>
      <el-form-item label="个人或单位地址:">
        <el-input v-model="formData.address" :disabled="true"></el-input>
      </el-form-item>
    </el-form>
    
  </div>
  <div class="d" v-if="formData.isBill == 1">
    <!--v-if="formData.isBill === 1 "-->
    <div class="order_title">发票信息</div>
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" class="form">
      <el-form-item label="发票抬头:">
        <el-input v-model="formData.mallPaymentInvoice.companyName" v-if="formData.mallPaymentInvoice.invoice  == 1" :disabled="true"></el-input>
        <el-input value="个人" :disabled="true" v-if="formData.mallPaymentInvoice.invoice  == 0"></el-input>
      </el-form-item>
      <el-form-item label="纳税人识别号:">
        <el-input v-model="formData.mallPaymentInvoice.taxpayerNumber" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="发票类型:">
        <el-select v-model="formData.mallPaymentInvoice.type" placeholder="发票类型" size="small" :disabled="true">
          <el-option label="增值税专用发票" :value="1"></el-option>
          <el-option label="增值税普通发票" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票扫描件:">
        <el-upload
            v-model="scanCopy"
            :action="uploadURL"
            :headers="myHeaders"
            list-type="picture-card"
            :on-preview="scanCopyPreview"
            :on-success="scanCopySuccess"
            :before-upload="pictureBeforeAvatarUpload"
            :limit="2"
            :file-list="scanCopyFileList"
            :show-file-list="true"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="scanCopyDialog" size="tiny">
          <img width="100%" :src="scanCopyView" alt="">
        </el-dialog>
      </el-form-item>
    </el-form>
  </div>
  <div class="d">
    <div class="order_title">订单详情</div>
    <el-table
        :data="commodityList"
        border
        highlight-current-row
        :span-method="objectSpanMethod"
        style="width: 100%"
    >
      <el-table-column
          type="index"
          label="序号"
          width="50"
          fixed="left"
      >
      </el-table-column>
      <el-table-column
          prop="commodityName"
          label="商品名称"
          fixed="left"
      >
      </el-table-column>
      <el-table-column
          prop="sku"
          label="型号"
          fixed="left"
          v-if="scoreType != 2"
          :formatter="f_sku"
      >
        <template slot-scope="scope">
          {{scope.row.sku | skuFilter}}
          <i v-if="scope.row.sku" style="cursor: pointer" @click="clickEdit(scope.row)" class="el-icon-edit"></i>
        </template>
      </el-table-column>
      <el-table-column
          prop="costPrice"
          label="原价"
          width="150"
      >
      </el-table-column>
      <el-table-column
          prop="amount"
          label="销售价格"
          width="150"
          :formatter="f_amount"
      >
      </el-table-column>
      <el-table-column
          prop="num"
          label="数量"
          width="100"
      >
      </el-table-column>
      <el-table-column
          prop="courseName"
          label="课程名称"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="操作"
          width="100"
      >
        <template slot-scope="scope">
          <el-button @click="updateCourse(scope.row)" type="text" size="small">修改课程</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-dialog
      title="选择型号"
      :visible.sync="choseType"
      :close-on-click-modal=false
      :before-close="handleClose"
  >
    <div>
      <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" class="form">
        <el-form-item v-for="modelType in modelTypeList" :label="modelType.specName">
          <el-radio-group v-model="typeSKU[modelType.skuSpecId]">
            <el-radio-button v-for="child in modelType.specOptionVoList" :label="child.skuSpecOptionId">{{child.specOptionName}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item >
          <el-button type="primary"  size="small" @click="saveSKU()">确认</el-button>
          <el-button type="primary" plain size="small"  @click="handleClose" >取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
  <el-dialog
      title="选择课程"
      :visible.sync="choseCommodity"
      :close-on-click-modal=false
      :before-close="handleClose"
  >
    
    <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top" style="margin-bottom: 10px">
      <el-row >
        <!--<el-col :span="5" class="cls-col">-->
          <!--<el-form-item label="所属机构" prop="orgCode">-->
            <!--<el-select size="small" placeholder="所属机构" clearable v-model="searchData.orgCode" @change="changeOrg" style="width: 100%" clearable >-->
              <!--<el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="5" class="cls-col">
          <el-form-item label="所属分类" prop="selectedOption">
            <el-cascader
                expand-trigger="hover"
                size="small"
                clearable
                :options="courseOptions"
                v-model="searchData.selectedOption"
                style="width: 100%"
                :props="{ value: 'courseTypeId', label: 'courseTypeName',children: 'childNodeLst'}"
            >
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="cls-col">
          <el-form-item label="课程名称" prop="name">
            <el-input v-model="searchData.name" placeholder="课程名称" size="small" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="cls-col">
          <el-form-item style="margin-top: 30px">
            <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    
    </el-form>
    
    <el-table
        :data="commodityData"
        ref="commodityList"
        @select="select"
        border>
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column
          prop="name"
          label="课程名称">
      </el-table-column>
      <el-table-column
          prop="orgName"
          label="机构"
      >
      </el-table-column>
      <el-table-column
          prop="ccName"
          label="课程分类"
          :formatter="f_categoryName"
      >
      
      </el-table-column>
    </el-table>
    <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="handleCurrentChange"
        style="margin-top: 5px; float: right; margin-right: 10px">
    </el-pagination>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="selectCommodity()">确 定</el-button>
    </div>
  </el-dialog>
</div>
  </el-container>
</template>

<script>

  import https from '@/https.js'
  import pdf from 'vue-pdf'
  import VueHoverMask from 'vue-hover-mask'
  
  export default {
    name: 'orderyhDetail',
    components: {
      pdf: pdf,
      VueHoverMask
    },
    data() {
      return {
        myHeaders: {
          Authentication: localStorage.getItem("token")
        },
        screenType: '',
        currentPage: 1,
        pageCount: 0,
        choseType: false,
        commodity: {},
        typeSKU: {},
        type1: "",
        type2: "",
        uploadURL: "",
        screenshot:"",
        screenshotDialog: false,
        scanCopy: '',
        scanCopyView:"",
        scanCopyDialog: false,
        oldAmount: 0,
        oldTotal: 0,
        oldRealPay: 0,
        isZH: false,
        scoreType: "",
        choseCommodity: false,
        changeCommodity: {},
        commodityData: [],
        courseOptions: [],
        org: [],
        commodity:{},
        total: 0,
        currentPage: 1,
        pageSize:10,
        searchData: {
          limit: 0,
          page: 1,
          name: '',
          ccId: '',
          categoryOne: "",
          categoryThree: "",
          categoryTwo: "",
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          courseType: '0',
          status: 2,
          orgCode: ''
        },
        labelPosition: 'right',
        loginOrgCode: "",
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        formData: {
          mallPaymentInvoice: {}
        },
        commodityList: [],
        obj: {},
        initPos: '',
        dialogVisible: false,
        pictureFileList: [],
        scanCopyFileList: [],
        modelTypeList: [],
        modelTypeChildren: [],
      };
    },
    methods: {
      handleClose() {
        this.choseCommodity = false;
        this.choseType = false;
        this.typeSKU = [];
        this.searchData.selectedOption=[];
        this.searchData.name = "";
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if(this.isZH) {
          if(this.scoreType != 2) {
            if(columnIndex == 4) {
              if(rowIndex == 0) {
                return {
                  rowspan: this.commodityList.length,
                  colspan: 1
                };
              } else {
                return {
                  rowspan: 0,
                  colspan: 0
                };
              }
            }
          } else {
            if(columnIndex == 3) {
              if(rowIndex == 0) {
                return {
                  rowspan: this.commodityList.length,
                  colspan: 1
                };
              } else {
                return {
                  rowspan: 0,
                  colspan: 0
                };
              }

            }
          }
        }
      },
      select(selection, row) {
        if (selection.length > 1) {
          let del_row = selection.shift()
          this.$refs.commodityList.toggleRowSelection(del_row, false)
        }
        this.changeCommodity = row;
      },
      showScreen() {

        if(!this.formData.screenshot) {
          return;
        }
        let a = this.formData.screenshot.split(".");
        if(a.length == 0) {
          return;
        }
        if(a[a.length-1] == "pdf") {
          window.open(this.formData.screenshot);
        } else {
          this.screenshotDialog = true;
        }
      },
      reUpload() {
        this.pictureFileList = [];
        this.formData.screenshot = "";
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      f_org(row, column, cellValue, index) {
        for(let o of this.org) {
          if(o.orgCode == cellValue) {
            return o.organizationName;
          }
        }
      },
      f_amount(row, column, cellValue, index) {
        if(this.isZH) {
          return this.formData.amount;
        }
        return cellValue;
      },
      f_categoryName(row, column, cellValue, index) {
        let categoryName = "";
        if(row.categoryOneName) {
          categoryName += row.categoryOneName;
        }
        if(row.categoryTowName) {
          categoryName += "/"+row.categoryTowName;
        }
        if(row.categoryThreeName) {
          categoryName += "/"+row.categoryThreeName;
        }
        return categoryName
      },
      f_sku(row, column, cellValue, index) {
        if(cellValue) {
          return cellValue
        } else {
          return "无"
        }
      },
      updateCourse(item) {
        this.commodity = item;
        this.search();
        this.searchCourseType();
        this.choseCommodity = true;
        
      },
      selectCommodity() {
        // /mallOrderInfo/changeCourse
        let courseId = this.changeCommodity.courseId;
        let params = {
          id: this.commodity.id,
          courseId: courseId,
        };
        this.https.fetchPost('/mallOrderInfo/changeCourse',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.$message({
              type: 'success',
              message: "课程更改成功"
            });
            this.commodity.courseName = this.changeCommodity.name
            this.choseCommodity = false;
            this.searchData.selectedOption=[];
            this.searchData.name = "";
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },
      search(val) {
        if(this.searchData.selectedOption.length > 0) {
          this.searchData.ccId = this.searchData.selectedOption[this.searchData.selectedOption.length-1];
        } else {
          this.searchData.ccId = '';
        }
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.limit = 10;
        let params = this.searchData;
        let selectedCourseType = this.searchData.selectedOption
        params.categoryOne = "";
        params.categoryTwo = "";
        params.categoryThree = "";
        if (selectedCourseType && selectedCourseType.length > 0) {
          
          
          switch (selectedCourseType.length) {
            case 1:
              params.categoryOne = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 2:
              params.categoryTwo = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 3:
              params.categoryThree = selectedCourseType[selectedCourseType.length - 1];
              break;
          }
        }
        
        this.https.fetchPost('/course/getCourseByType',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.commodityData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },
      searchById(orderId) {
        // /mallOrderInfo/selectMallOrderInfoVoByMallOrderInfo
        let params = {
          orderId: orderId,
        }
        https.fetchPost('/mallOrderInfo/detail',params,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            let formData = data.data.data
            this.formData = formData;
            let passportName = (formData.passportFirstName?formData.passportFirstName:'')+ " "+ (formData.passportLastName?formData.passportLastName:'');
            this.$set(this.formData,"passportName",passportName);
            if(this.formData.bankFee) {
              this.$set(this.formData,"totalDynamic",this.formData.amount+this.formData.bankFee);
            } else {
              this.$set(this.formData,"totalDynamic",this.formData.amount);
            }
            if(this.formData.screenshot) {
              let a = this.formData.screenshot.split(".");
              if(a[a.length-1] == "pdf") {
                this.screenType = 'pdf';
              } else {
                this.screenType = 'img';
              }
              let pictureFile = {
                name: "汇款截图.jpg",
                url: this.formData.screenshot
              };
              this.pictureFileList.push(pictureFile);
            }
            
            if(this.formData.mallPaymentInvoice && this.formData.mallPaymentInvoice.scanCopyView) {
              let invoiceFile = {
                name: "汇款截图.jpg",
                url: this.formData.mallPaymentInvoice.scanCopyView
              };
              this.scanCopyFileList.push(invoiceFile);
            }
            
            this.searchData.orgCode = this.formData.org;
            this.commodityList = data.data.data.snapshotVos;
            for(let commodity of data.data.data.snapshotVos) {
              this.scoreType = commodity.type;
              if(commodity.type == 4) {
                this.isZH = true;
              }
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
          }
        }).catch(err=>{
              console.log(err)
              this.$message.error('数据加载失败');
            }
        )
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      updateAmount(flag) {
        // /mallOrderInfo/pricing
        let params = {};
        
        if(flag == 'amount') {
          params = {
            orderId: this.formData.orderId,
            amount: this.formData.amount,
          };
        }
        if(flag == 'total') {
          params = {
            orderId: this.formData.orderId,
            total: this.formData.total,
          };
        }
        if(flag == 'realPay') {
          params = {
            orderId: this.formData.orderId,
            realPay: this.formData.realPay,
          };
        }
        https.fetchPost('/mallOrderInfo/pricing',params ,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
            if(flag == 'amount') {
              this.formData.amount = this.oldAmount;
            }
            if(flag == 'total') {
              this.formData.total = this.oldTotal;
            }
            if(flag == 'realPay') {
              this.formData.realPay = this.oldRealPay;
            }
            

          }
        }).catch(err=>{
              this.$message.error('数据加载失败');
            }
        )


      },
      updatePayStatus(flag) {
        // /mallOrderInfo/pricing
        let params = {};
        
        if(flag == 'paymentStatus') {
          params = {
            orderId: this.formData.orderId,
            paymentStatus: this.formData.paymentStatus,
          };
        }
        console.log('订单状态修改',params);
        https.fetchPost('/mallOrderInfo/updateOrderPayStatus',params ,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
            if(flag == 'amount') {
              this.formData.amount = this.oldAmount;
            }
            if(flag == 'total') {
              this.formData.total = this.oldTotal;
            }
            if(flag == 'realPay') {
              this.formData.realPay = this.oldRealPay;
            }
            

          }
        }).catch(err=>{
              this.$message.error('数据加载失败');
            }
        )


      },
      changeOrg() {
        this.searchCourseType();
      },
      searchCourseType() {
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        this.https.fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseOptions = data.data.data.childNodeLst;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      handlePictureCardPreview(file) {
        this.screenshot = file.url;
        this.screenshotDialog = true;
      },
      scanCopyPreview(file) {
        this.scanCopyView = file.url;
        this.scanCopyDialog = true;
      },
      pictureHandleSuccess(response, file, fileList) {
        this.pictureFileList = [];
        if(response.code == 200) {
          this.formData.screenshot = response.data.filePath;
          let a = this.formData.screenshot.split(".");
          if(a[a.length-1] == "pdf") {
            this.screenType = 'pdf';
          } else {
            this.screenType = 'img';
          }
          let file = {
            name: "汇款截图",
            url: response.data.filePath
          };
          this.pictureFileList.push(file);
          this.updatePicture(1);
          
        } else {
          this.$message.error('上传图片失败!');
        }

      },
      scanCopySuccess(response, file, fileList) {
        this.scanCopyFileList = [];
        if(response.code == 200) {
          this.formData.mallPaymentInvoice.scanCopyView = response.data.filePath;
          this.formData.mallPaymentInvoice.scanCopy = response.data.fileId;
          let file = {
            name: "发票扫描",
            url: response.data.filePath
          };
          this.scanCopyFileList.push(file);
          this.updatePicture(2);

        } else {
          this.$message.error('上传图片失败!');
        }
      },
      updatePicture(flag) {
        // flag 1,汇款截图 2，发票扫描
        let params = {};
        if(flag == 1) {
          params = {
            orderId: this.formData.orderId,
            remittance: this.formData.remittance,
            screenshot: this.formData.screenshot
          };
        }
        if(flag == 2) {
          params = {
            orderId: this.formData.orderId,
            isBill: this.formData.isBill,
            piId: this.formData.mallPaymentInvoice.piId,
            scanCopy: this.formData.mallPaymentInvoice.scanCopy
          };
        }
        https.fetchPost('/mallOrderInfo/creatMallOrderInfo',params ,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            if(flag == 1) {
              this.$message({
                type: 'success',
                message: '汇款截图上传成功!'
              });
            }
            if(flag == 2) {
              this.$message({
                type: 'success',
                message: '发票扫描件上传成功!'
              });
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
            if(flag == 1) {
              this.scanCopyFileList = [];
            }
            if(flag == 2) {
              this.pictureFileList = [];
            }
          }
        }).catch(err=>{
              this.$message.error('数据加载失败');
            }
        )
      },

      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type=="application/pdf";
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('只能上传 JPG/PNG/BMP/PDF 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 2MB!');
        }
        /*const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 388;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width/img.height == 16/9;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传图片尺寸必须为16:9!');
          return Promise.reject();
        });*/
        return isJPG && isLt2M;
      },
      
      pictureBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        /*const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 388;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width/img.height == 16/9;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传图片尺寸必须为16:9!');
          return Promise.reject();
        });*/
        return isJPG && isLt2M;
      },
      clickEdit(commodity) {
        this.commodity = commodity;
        let params = {
          commodityId: commodity.commodityId
        };
        this.https.fetchPost('/commodityInfo/getSpecDiableList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.modelTypeList = data.data.data;
            this.choseType = true;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      
      saveSKU() {
        let idList=[];
        for(let m in this.typeSKU){
          idList.push(this.typeSKU[m])
        }
        if(idList.length != this.modelTypeList.length) {
          this.$message.error('请选择课程型号');
          return;
        }
        
        let params = {
          commodityId:this.commodity.commodityId,
          idList: idList
        };
        this.https.fetchPost('/commodityInfo/selectBySku', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
          let sku = data.data.data;
          this.changeCourse(sku);
          
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      changeCourse(data) {
        let params = {
          id: this.commodity.id,
          skuId: data.skuId
        };
        this.https.fetchPost('/mallOrderInfo/changeCourse', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let skuName = ""
            for(let m in this.typeSKU ) {
              for(let modelType of this.modelTypeList) {
                if(modelType.skuSpecId == m) {
                  for(let skuSpec of modelType.specOptionVoList) {
                    if(skuSpec.skuSpecOptionId == this.typeSKU[m]) {
                      skuName +=skuSpec.specOptionName+"；"
                    }
                  }
                }
              }
            }
            this.commodity.sku = skuName.substr(0,skuName.length-1);
            this.commodity.courseName = data.data.data;
            this.typeSKU = [];
            this.choseType = false;
            this.$message({
              type: 'success',
              message: '型号已修改成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
    },
    filters: {
      skuFilter(val) {
        if(val) {
          return val
        } else {
          return "无"
        }
      }
    },
    watch: {
      'formData.amount'(newData, old){
        this.oldAmount = old;
      },
      'formData.total'(newData, old){
        this.oldTotal = old;
      },
      'formData.realPay'(newData, old){
        this.oldRealPay = old;
      },
      
    },
    created: function() {
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
      this.loginOrgCode = this.$store.state.orgCode;
      let orderId = this.$route.query.orderId;
      if (orderId) {
        this.searchById(orderId);
        this.selectOrg();
        this.searchCourseType();
      }else {
        this.$router.push({
          name: "ordyher"
        })
        return
      }
    }
  };
</script>

<style scoped>
  .image {
    width: 100%;
    display: block;
  }
  .d {
    width: 60%;
    margin: 20px 0 0 50px;
    border-radius: 10px;
    border: 1px solid #DCDFE6;
    padding-bottom: 40px;
    display: block;
  }

  .order_title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    background: #f0f0f0;
    margin-bottom: 20px;
    padding-left: 40px;
  }

  .form {
    border: 1px solid #DCDFE6;
    border-radius: 10px;
    padding-top: 15px;
    background: #f0f0f0;
    margin: 0 40px;
    padding-right: 5px;
  }
</style>